<template>
<div>

  <div class="container-fluid">

    <div class="navbar-expand-lg navbar-danger mb-3">

<!--      <ul class="nav nav-pills">-->
<!--        <li class="nav-item">-->
<!--&lt;!&ndash;          <a class="nav-link" href="#">Flag History</a>&ndash;&gt;-->
<!--          <router-link :to="{name: 'FlagHistoryIndex' }"-->
<!--                       class="nav-link border border-bottom-0"-->
<!--                       :class="{'active': isActiveRoute('FlagHistoryIndex')}"-->
<!--          > Flag History-->
<!--          </router-link>-->

<!--        </li>-->
<!--        <template>-->
<!--          <li class="nav-item" v-if="!guest">-->
<!--            <router-link :to="{name: 'ManagementHistoryIndex' }"-->
<!--                         class="nav-link border border-bottom-0"-->
<!--                         :class="{'active': isActiveRoute('ManagementHistoryIndex')}"-->
<!--            > Vessel Management History-->
<!--            </router-link>-->
<!--          </li>-->
<!--          <li class="nav-item">-->
<!--            <router-link :to="{name: 'ManningHistoryIndex' }"-->
<!--                         class="nav-link border border-bottom-0"-->
<!--                         :class="{'active': isActiveRoute('ManningHistoryIndex')}"-->
<!--            > Manning History-->
<!--            </router-link>-->
<!--          </li>-->
<!--        </template>-->
<!--      </ul>-->


      <nav class="bg-light">
        <div class="nav nav-pills nav-fill w-100" id="nav-tab" role="tablist">
          <li class="nav-item">
            <router-link
                :to="{name: 'FlagHistoryIndex' }"
                tag="a"
                class="nav-link border border-bottom-0"
                :class="{'active': isActiveRoute('FlagHistoryIndex')}"
                role="tab"
                data-toggle="list"
            >
              Flag History
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{name: 'ManagementHistoryIndex' }"
                         tag="a"
                         class="nav-link border border-bottom-0"
                         :class="{'active': isActiveRoute('ManagementHistoryIndex')}"
                         role="tab"
                         data-toggle="list"
            > Vessel Management History
            </router-link>
          </li>


          <li class="nav-item">
            <router-link :to="{name: 'ManningHistoryIndex' }"
                         tag="a"
                         class="nav-link border border-bottom-0"
                         :class="{'active': isActiveRoute('ManningHistoryIndex')}"
                         role="tab"
                         data-toggle="list"
            > Manning History
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{name: 'VesselOwnerHistory' }"
                         tag="a"
                         class="nav-link border border-bottom-0"
                         :class="{'active': isActiveRoute('VesselOwnerHistory')}"
                         role="tab"
                         data-toggle="list"
            > Owner History
            </router-link>
          </li>

        </div>
      </nav>

    </div>

    <main>
      <router-view/>
    </main>

  </div>

</div>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';
import { gateMixin } from "@/mixins/gateMixin";

export default {
  name: 'VesselHistory',

  mixins: [ vueAppMixin, gateMixin ],

};
</script>

<style scoped>

</style>
